"use client";

import { useState } from "react";

import { ContactConsultant } from "@/app/components/shared/contact-consultant";
import { useConsultantStore } from "@/app/store";
import { ConsultantSlimBanner } from "@/composites/consultant";

const HEADLINE = "Got questions?";
const PROFILE_IMAGE_HOST = "https://www.pamperedchef.com";
const DEFAULT_PROFILE_IMAGE = `${PROFILE_IMAGE_HOST}/iceberg/pws/profilepic/default-profilepic.jpg`;
const FIND_CONSULTANT_HREF = "/find-a-consultant-party";

export interface ConsultantBannerProps {
	captchaSiteKey?: string;
}

export function ConsultantBanner({
	captchaSiteKey
}: ConsultantBannerProps): JSX.Element {
	const consultantState = useConsultantStore(
		(state) => state.consultantState
	);
	const [isContactOpen, setIsContactOpen] = useState(false);

	if (consultantState.status === "connected") {
		const image =
			consultantState.image !== ""
				? `${PROFILE_IMAGE_HOST}/${consultantState.image}`
				: DEFAULT_PROFILE_IMAGE;
		const name = `${consultantState.firstName} ${consultantState.lastName}`;

		return (
			<>
				<ConsultantSlimBanner
					headline={HEADLINE}
					headlineTag="h2"
					description="You can always contact your consultant for inspiration or details on using this product."
					consultant={{
						name,
						image,
						consultantNumber: consultantState.consultantNumber
					}}
					consultantLabel="Your Consultant:"
					cta={{
						children: "Contact Me",
						onPress: () => setIsContactOpen(true)
					}}
				/>
				{isContactOpen ? (
					<ContactConsultant
						triggerElement={null}
						consultant={{
							consultantNumber: consultantState.consultantNumber,
							image,
							name
						}}
						thankYouMessage={{
							title: "Message Sent to Your Consultant",
							description: `Thanks for reaching out. Your message was sent successfully, and ${name} will follow up with you soon.`
						}}
						captchaSiteKey={captchaSiteKey ?? ""}
						openByDefault={isContactOpen}
						onClose={() => setIsContactOpen(false)}
					/>
				) : null}
			</>
		);
	}

	return (
		<ConsultantSlimBanner
			headline={HEADLINE}
			headlineTag="h2"
			description="Our consultants can help you with finding inspiration or details on using this product."
			cta={{ children: "Find a Consultant", href: FIND_CONSULTANT_HREF }}
		/>
	);
}
